import { requester } from "App";
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { formatLocalDate } from "shared/utils/Utils";
import Dummy from "components/Dummy";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faReceipt } from "@fortawesome/free-solid-svg-icons";
import { devLog } from "utils/logger";

function ReceiptDetail() {
    const location = useLocation();
    const navigate = useNavigate();
    const { id } = useParams();
    const [orderData, setOrderData] = useState(null);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        if (location?.state?.data) {
            devLog(location?.state?.data);
            setOrderData(location.state.data);
        }
    }, [location]);

    const copyToClipboard = async (text) => {
        try {
            // 최신 브라우저의 Clipboard API 사용
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(text);
                setToastMessage('주문번호가 복사되었습니다');
                setShowToast(true);
                setTimeout(() => {
                    setShowToast(false);
                }, 2000);
            } else {
                // fallback: execCommand 사용
                const textArea = document.createElement('textarea');
                textArea.value = text;
                textArea.style.position = 'fixed';
                textArea.style.left = '-999999px';
                textArea.style.top = '-999999px';
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                
                const successful = document.execCommand('copy');
                document.body.removeChild(textArea);
                
                if (successful) {
                    setToastMessage('주문번호가 복사되었습니다');
                    setShowToast(true);
                    setTimeout(() => {
                        setShowToast(false);
                    }, 2000);
                } else {
                    throw new Error('execCommand 복사 실패');
                }
            }
        } catch (err) {
            console.error('클립보드 복사 실패:', err);
            setToastMessage('복사에 실패했습니다');
            setShowToast(true);
            setTimeout(() => {
                setShowToast(false);
            }, 2000);
        }
    };

    const handleDeleteOrder = async () => {
        setIsDeleting(true);
        
        requester.deletedByPurchaseOrder({ id: orderData.id }, (result) => {
            setIsDeleting(false);
            setShowDeleteModal(false);
            
            if (result.code === 0) {
                setToastMessage('주문서가 삭제되었습니다');
                setShowToast(true);
                setTimeout(() => {
                    navigate(`/ws/${id}/mobile/orderHistory`, { replace: true });
                }, 1500);
            } else {
                setToastMessage('삭제에 실패했습니다');
                setShowToast(true);
                setTimeout(() => {
                    setShowToast(false);
                }, 2000);
            }
        });
    };

    if (!orderData) {
        return (
            <Center height={"90vh"}>
                <P color={"#666"}>주문 정보를 불러오는 중...</P>
            </Center>
        );
    }

    return (
        <div style={{ height: "100%", backgroundColor: "#f5f5f5" }}>
            {/* 헤더 공간 */}
            <Dummy height={"60px"} />
            
            {/* 영수증 컨테이너 */}
            <div style={{ padding: '20px' }}>
                <div style={{
                    backgroundColor: '#fff',
                    borderRadius: '12px',
                    padding: '24px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    border: '1px solid #e0e0e0'
                }}>
                    <VerticalFlex gap={24}>
                        {/* 영수증 헤더 */}
                        <Center>
                            <VerticalFlex gap={8}>
                                <P size={20} weight={700} color="#333">PUFFU 자판기</P>
                                <P size={14} color="#666">구매 영수증</P>
                                <div style={{
                                    width: '60px',
                                    height: '2px',
                                    backgroundColor: 'var(--main-color)',
                                    margin: '8px auto'
                                }} />
                            </VerticalFlex>
                        </Center>

                        {/* 주문 정보 */}
                        <VerticalFlex gap={12}>
                            <HorizontalFlex justifyContent="space-between">
                                <FlexChild>
                                    <P size={14} color="#666">주문번호</P>
                                </FlexChild>
                                <FlexChild justifyContent={"flex-end"}>
                                    <P
                                        size={14}
                                        weight={500}
                                        color="#333"
                                        onClick={() => copyToClipboard(orderData.id)}
                                        cursor="pointer"
                                        textDecoration="underline"
                                    >
                                        {orderData.id}
                                    </P>
                                </FlexChild>
                            </HorizontalFlex>
                            <HorizontalFlex justifyContent="space-between">
                                <P size={14} color="#666">구매일시</P>
                                <P size={14} weight={500} color="#333">
                                    {(() => {
                                        const date = new Date(orderData.createDateTime);
                                        const year = date.getFullYear();
                                        const month = String(date.getMonth() + 1).padStart(2, '0');
                                        const day = String(date.getDate()).padStart(2, '0');
                                        const hours = String(date.getHours()).padStart(2, '0');
                                        const minutes = String(date.getMinutes()).padStart(2, '0');
                                        return `${year}.${month}.${day} ${hours}:${minutes}`;
                                    })()}
                                </P>
                            </HorizontalFlex>
                            <HorizontalFlex justifyContent="space-between">
                                <FlexChild width="max-content">
                                    <P size={14} color="#666">결제상태</P>
                                </FlexChild>
                                <FlexChild flex={1} justifyContent="flex-end">
                                    <div style={{
                                        padding: "4px 8px",
                                        backgroundColor: orderData.deliveryStatus === "WaitingForPayment" ? "#fff3cd" : "#d4edda",
                                        borderRadius: "4px",
                                        border: `1px solid ${orderData.deliveryStatus === "WaitingForPayment" ? "#ffeaa7" : "#c3e6cb"}`,
                                        width: "max-content"
                                    }}>
                                        <P size={12} color={orderData.deliveryStatus === "WaitingForPayment" ? "#856404" : "#155724"} weight={500}>
                                            {orderData.deliveryStatus === "WaitingForPayment" ? "결제대기" : "구매완료"}
                                        </P>
                                    </div>
                                </FlexChild>
                            </HorizontalFlex>
                        </VerticalFlex>

                        {/* 구분선 */}
                        <div style={{ height: '1px', backgroundColor: '#e0e0e0' }} />

                        {/* 구매 상품 목록 */}
                        <VerticalFlex gap={16}>
                            <P size={16} weight={600} color="#333">구매 상품</P>
                            {orderData.orderProducts.map((product, index) => (
                                <div key={product.id || index}>
                                    <HorizontalFlex gap={12} alignItems="flex-start">
                                        <FlexChild width={50} height={50} flexShrink={0}>
                                            <div style={{
                                                width: "100%",
                                                height: "100%",
                                                borderRadius: "6px",
                                                overflow: "hidden",
                                                backgroundColor: "#f5f5f5",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                {product.productImg ? (
                                                    <img
                                                        src={product.productImg}
                                                        alt={product.productName}
                                                        style={{
                                                            width: "100%",
                                                            height: "100%",
                                                            objectFit: "cover"
                                                        }}
                                                    />
                                                ) : (
                                                    <P size={10} color="#999">이미지</P>
                                                )}
                                            </div>
                                        </FlexChild>
                                        <FlexChild flex={1}>
                                            <VerticalFlex gap={4} flexStart>
                                                <P color="#333" size={14} weight={500} style={{ lineHeight: '1.4' }}>
                                                    {product.productName}
                                                </P>
                                                <HorizontalFlex justifyContent="space-between" alignItems="center">
                                                    <P color="#666" size={12}>
                                                        {product.price.toLocaleString()}원 × {product.quantity}개
                                                    </P>
                                                    <P color="#333" size={14} weight={600}>
                                                        {(product.price * product.quantity).toLocaleString()}원
                                                    </P>
                                                </HorizontalFlex>
                                            </VerticalFlex>
                                        </FlexChild>
                                    </HorizontalFlex>
                                    {/* {index < orderData.orderProducts.length - 1 && (
                                        <div style={{ height: '1px', backgroundColor: '#f0f0f0', margin: '12px 0' }} />
                                    )} */}
                                </div>
                            ))}
                        </VerticalFlex>

                        {/* 구분선 */}
                        <div style={{ height: '1px', backgroundColor: '#e0e0e0' }} />

                        {/* 결제 정보 */}
                        <VerticalFlex gap={12}>
                            <P size={16} weight={600} color="#333">결제 정보</P>

                            <HorizontalFlex justifyContent="space-between">
                                <P size={14} color="#666">상품 금액</P>
                                <P size={14} weight={500} color="#333">
                                    {orderData.orderProducts.reduce((sum, product) => sum + (product.price * product.quantity), 0).toLocaleString()}원
                                </P>
                            </HorizontalFlex>

                            {orderData.usedPoints > 0 && (
                                <HorizontalFlex justifyContent="space-between">
                                    <P size={14} color="#666">포인트 사용</P>
                                    <P size={14} weight={500} color="#ff6600">
                                        -{orderData.usedPoints.toLocaleString()}원
                                    </P>
                                </HorizontalFlex>
                            )}
                            {orderData.paymentDetail && (
                                <HorizontalFlex justifyContent="space-between">
                                    <P size={14} color="#666">결제 정보</P>
                                    <P size={14} weight={500} color="#333">{orderData.paymentDetail}</P>
                                </HorizontalFlex>
                            )}

                            {/* 최종 결제 금액 */}
                            <div style={{
                                padding: '12px 0',
                                borderTop: '2px solid #333',
                                marginTop: '8px'
                            }}>
                                <HorizontalFlex justifyContent="space-between" alignItems="center">
                                    <P size={16} weight={700} color="#333">총 결제금액</P>
                                    <P size={18} weight={700} color="var(--main-color)">
                                        {orderData.amount.toLocaleString()}원
                                    </P>
                                </HorizontalFlex>
                            </div>
                        </VerticalFlex>

                        {/* 하단 안내 */}
                        <div style={{
                            padding: '16px',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '8px',
                            border: '1px solid #e9ecef'
                        }}>
                            <VerticalFlex gap={8}>
                                <P size={14} weight={600} color="#333">고객센터 안내</P>
                                <P size={12} color="#666" style={{ lineHeight: '1.5' }}>
                                    • 교환/반품 문의: 고객센터 070-4242-2000<br />
                                    • 영수증 재발행: 주문내역에서 확인 가능<br />
                                    • 주문서 삭제 후 복구가 불가능하니 신중하게 선택해주세요!
                                </P>
                            </VerticalFlex>
                        </div>

                        {/* 주문서 삭제 버튼 */}
                        <div style={{
                            padding: '16px 0',
                            borderTop: '1px solid #e0e0e0',
                            marginTop: '16px'
                        }}>
                            <button
                                onClick={() => setShowDeleteModal(true)}
                                style={{
                                    width: '100%',
                                    padding: '12px',
                                    backgroundColor: 'transparent',
                                    color: '#ff4757',
                                    border: '1px solid #ff4757',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    cursor: 'pointer',
                                    fontWeight: '500'
                                }}
                            >
                                주문서 삭제
                            </button>
                        </div>
                    </VerticalFlex>
                </div>
            </div>

            <Dummy height={"80px"} backgroundColor="#f5f5f5" />

            {/* 삭제 확인 모달 */}
            {showDeleteModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 999999,
                    padding: '20px'
                }}>
                    <div style={{
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        padding: '24px',
                        width: '100%',
                        maxWidth: '320px',
                        boxShadow: '0 10px 40px rgba(0,0,0,0.3)'
                    }}>
                        <VerticalFlex gap={20}>
                            <Center>
                                <VerticalFlex gap={8}>
                                    <div style={{
                                        width: '50px',
                                        height: '50px',
                                        borderRadius: '50%',
                                        backgroundColor: '#fee',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        margin: '0 auto 8px'
                                    }}>
                                        <span style={{ fontSize: '24px', color: '#ff4757' }}>⚠️</span>
                                    </div>
                                    <P size={18} weight={600} color="#333">주문서 삭제</P>
                                    <P size={14} color="#666" style={{ lineHeight: '1.5', textAlign: 'center' }}>
                                        정말로 이 주문서를 삭제하시겠습니까?<br />
                                        삭제된 주문서는 복구할 수 없습니다.
                                    </P>
                                </VerticalFlex>
                            </Center>

                            <HorizontalFlex gap={12}>
                                <FlexChild>
                                    <button
                                        onClick={() => setShowDeleteModal(false)}
                                        disabled={isDeleting}
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            backgroundColor: '#f8f9fa',
                                            color: '#666',
                                            border: 'none',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            cursor: isDeleting ? 'not-allowed' : 'pointer',
                                            fontWeight: '500',
                                            opacity: isDeleting ? 0.5 : 1
                                        }}
                                    >
                                        취소
                                    </button>
                                </FlexChild>
                                <FlexChild>
                                    <button
                                        onClick={handleDeleteOrder}
                                        disabled={isDeleting}
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            backgroundColor: '#ff4757',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            cursor: isDeleting ? 'not-allowed' : 'pointer',
                                            fontWeight: '500',
                                            opacity: isDeleting ? 0.7 : 1
                                        }}
                                    >
                                        {isDeleting ? '삭제 중...' : '삭제'}
                                    </button>
                                </FlexChild>
                            </HorizontalFlex>
                        </VerticalFlex>
                    </div>
                </div>
            )}

            {/* Toast 메시지 */}
            {showToast && (
                <div style={{
                    position: 'fixed',
                    bottom: '100px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: '#333',
                    color: '#fff',
                    padding: '12px 20px',
                    borderRadius: '8px',
                    fontSize: '14px',
                    zIndex: 1000,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                    animation: 'fadeInOut 2s ease-in-out'
                }}>
                    {toastMessage}
                </div>
            )}
            
            <style jsx>{`
                @keyframes fadeInOut {
                    0% { opacity: 0; transform: translateX(-50%) translateY(10px); }
                    20% { opacity: 1; transform: translateX(-50%) translateY(0); }
                    80% { opacity: 1; transform: translateX(-50%) translateY(0); }
                    100% { opacity: 0; transform: translateX(-50%) translateY(-10px); }
                }
            `}</style>
        </div>
    );
}

export default ReceiptDetail;